import { render } from "./BusinessDetails.vue?vue&type=template&id=6f5c501f&scoped=true&ts=true"
import script from "./BusinessDetails.vue?vue&type=script&lang=ts"
export * from "./BusinessDetails.vue?vue&type=script&lang=ts"

import "./BusinessDetails.vue?vue&type=style&index=0&id=6f5c501f&lang=scss&scoped=true"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5c501f"]])

export default __exports__